import type { McpServerSpec } from "@p0security/shared/types/agentic/mcp";

export const rdsPostgresMcp: McpServerSpec = {
  type: "container",
  label: "PostgreSQL on AWS RDS",
  // copy-paste instead of import to avoid import cycle
  iconUrl:
    "https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg",
  transport: "stdio",
  container: {
    image: { image: "p0security/mcp-rds-postgres:0.3.0-rds-ca-20261007" },
    args: [],
    envs: {
      DATABASE_URI:
        "postgresql://{{credential.dbUser|urlencode}}:{{credential.token|urlencode}}@{{credential.hostname}}:{{credential.port}}/{{credential.database|urlencode}}?sslmode=verify-full&sslrootcert=/etc/ssl/certs/ca-certificates.crt",
    },
  },
  credential: {
    type: "rds-iam",
    // A pg role grant delegates through aws-rds, aws, and aws-oidc.
    awsRoleArn:
      "{{ request.delegation[0].request.delegation[0].request.delegation[0].request.generated.arn }}",
    hostname: "{{ request.generated.hostname }}",
    port: "{{ request.generated.port }}",
    dbUser: "{{ request.generated.dbUser }}",
    database: "{{ request.permission.database }}",
    region:
      "{{ request.delegation[0].request.permission.arn | split: ':' | slice: 3 | first }}",
  },
  authorization: "upstream",
  access: {
    prompt:
      'Request PostgreSQL role access with argv: ["--instance", <instance>, "--database", <database>, <role>, "--reason", <reason>]. Use the database role that has only the permissions needed for this task.',
    prefixArgs: ["postgres", "role"],
  },
  list: {
    fields: {
      instance: { description: "PostgreSQL instance ID", required: [] },
      database: {
        description: "Target database name",
        required: ["instance"],
      },
      name: {
        description: "PostgreSQL role to grant",
        required: ["instance"],
      },
    },
    prefixArgs: ["postgres", "role"],
  },
  location: {
    key: "instance",
    description: "PostgreSQL instance ID",
  },
  tools: {
    type: "manual",
    tools: [
      {
        name: "list_schemas",
        description: "List all schemas in the database",
        inputSchema: { type: "object", properties: {} },
      },
      {
        name: "list_objects",
        description: "List tables, views, sequences, or extensions in a schema",
        inputSchema: {
          type: "object",
          properties: {
            schema_name: { type: "string", description: "Schema name" },
            object_type: {
              type: "string",
              description: "Object type: table, view, sequence, or extension",
            },
          },
          required: ["schema_name"],
        },
      },
      {
        name: "get_object_details",
        description:
          "Get metadata about an object, including columns, constraints, and indexes",
        inputSchema: {
          type: "object",
          properties: {
            schema_name: { type: "string", description: "Schema name" },
            object_name: { type: "string", description: "Object name" },
            object_type: { type: "string", description: "Object type" },
          },
          required: ["schema_name", "object_name"],
        },
      },
      {
        name: "execute_sql",
        description: "Execute a SQL query against the database",
        inputSchema: {
          type: "object",
          properties: { sql: { type: "string", description: "SQL to run" } },
          required: ["sql"],
        },
      },
    ],
  },
};
